import { faLayerGroup } from '@fortawesome/pro-light-svg-icons/faLayerGroup';
import { PageResult } from '@spike/model';
import { Room } from '@spike/room-model';
import { fetchThunk as fetchRoomsThunk } from '@spike/rooms-action';
import Filter from 'components/Bookings2/List/Filter/Filter';
import { useApiClientWrapper } from 'hooks';
import useOrganizationMarketplaces from 'hooks/useOrganizationMarketplaces';
import { FunctionComponent, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

interface RoomsFilterProps {
    selected: Array<number>;
    className?: string;
    onChangeSelection?: (selectedRoomIds: Array<number>) => void;
}

export const RoomsFilter: FunctionComponent<RoomsFilterProps> = props => {
    const dispatch = useDispatch();
    const apiClientWrapper = useApiClientWrapper();
    const { organizationMarketplaces } = useOrganizationMarketplaces();

    const marketplaceIds = useMemo(
        () => organizationMarketplaces.map(marketplace => marketplace.id),
        [organizationMarketplaces]
    );

    const rooms = useSelector<RootState, PageResult<Room>>(state => state.rooms.rooms);

    useEffect(() => {
        dispatch(fetchRoomsThunk(apiClientWrapper, 1, 3210, marketplaceIds));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const options = useMemo(
        () =>
            rooms.page
                .filter(room => room.id != null)
                .map(room => ({ id: room.id!, name: room.name }))
                .sort((a, b) => a.name.localeCompare(b.name)),
        [rooms.page]
    );

    return (
        <Filter
            allLabel="All Rooms"
            quantityLabel="rooms"
            icon={faLayerGroup}
            options={options}
            selectedOptions={options.filter(option => props.selected.includes(option.id))}
            onChangeSelection={selected => props.onChangeSelection?.(selected.map(option => option.id))}
            className={props.className}
        />
    );
};

export default RoomsFilter;
